import { Button, Helper, Icon, MenuBar, StandaloneIcon, TemplateTable, TruncateToolTip } from 'Components';
import menuOptions from 'constants/menuOptions';
import needDollarSign from 'constants/need-currency';
import moneyFormatter from 'helpers/money-formatter';
import rowRules from 'helpers/rowRules';
import i18n from 'i18next';
import React, { Fragment } from 'react';
import SplitReportSubTableTemplate from './SplitReportSubTableTemplate';


const SplitReportTableTemplate = (props) => {
  const {
    onMoreVertClick,
    onMenuClick,
    onTrExpand,
    handleDownload,
    setAppState,
    tableIndex,
    // keyPairs,
    // viewCode,
    isRowLoading,
    menuRow,
    data,
    keys,
    Expanded = data[tableIndex].Expanded,
    isCompleted = data[tableIndex].Status === "C",
    tempUpdateSplitReportRequestData,
  } = props;


  //! Sub Table's Keys and Key Pairs:
  const subKeys = ["ReportNumber", "ReportName", "ReportDate", "DownloadLink"]
  const subKeyPairs = { ReportNumber: i18n.t('splitReports:Report #'), ReportName: i18n.t("splitReports:Report Name"), ReportDate: i18n.t("splitReports:Report Date"), DownloadLink: i18n.t("splitReports:Download Link") }

  return (
    <Fragment>
      <tr onClick={e => { onMoreVertClick(e, tableIndex) }}>


        {/* ! This is the + / - buttons for expanding a row.  */}
        {!!isCompleted ? <td>
          <Helper text={i18n.t('tutorials:invoices.2')}>
            <Button onClick={e => onTrExpand(e, tableIndex)}>
              <Icon icon={Expanded ? 'remove' : 'add'} />
            </Button>
          </Helper>
        </td> : <td> </td>}


        {/* ! This the table values */}
        {
          keys.map(key => (
            <td key={key}>
              {formatRow(key, props[key])}
            </td>
          ))
        }


        {/* ! The rows menu options */}
        <td className="template-table__td--menu-slot">
          <MenuBar
            tableIndex={tableIndex}
            onClick={onMenuClick}
            currentRow={data[tableIndex]}
            show={tableIndex === menuRow}
            icons={menuOptions && menuOptions.filter(option => rowRules && rowRules.splitReport(option, props))}
          />
        </td>


        {/* ! The rows menu icon */}
        <td className="template-table__td--menu-icon">
          <Helper text={i18n.t('tutorials:invoices.5')} placement="bottom-left">
            <StandaloneIcon
              onClick={(e) => {
                e.preventDefault();
                onMoreVertClick(e, tableIndex);
              }}
              icon={data[tableIndex] && data[tableIndex].Status !== "S" && "more_vert"}
              hasNoBackground
            />
          </Helper>
        </td>
      </tr>


      {/* ! This is the expanded sub-row.  */}
      {
        Expanded &&
        <tr className="invoices-list__template-expanded__tr">
          <td colSpan="14" className="invoices-list__template-expanded__td">
            <div className="invoices-list__template-expanded__table-wrapper">

              {/* ! this is the template for the Sub Table will be displayed when expanded == true.  */}
              <TemplateTable
                {...props}
                keys={subKeys}
                keyPairs={subKeyPairs}
                data={data[tableIndex].SplitReports}
                handleDownload={handleDownload}
                // ! SUB TABLE TEMPLATE
                template={SplitReportSubTableTemplate}
                viewCode={"subSplitReports"}
                setAppState={setAppState}
                isDraggable
                onSettingClick={() => { }}
                isRowLoading={isRowLoading}
                // hasSettings
                isLoading={data[tableIndex].isJobsTableLoading}
              />
            </div>
          </td>
        </tr>
      }
    </Fragment >
  );
};



function formatRow(key, value = '') {
  if (key === 'CreatedDate' || key === 'ModifiedDate' || key === 'Submitted') {
    if (!value || value === '-') return '-';
    return new Date(value).toLocaleDateString();
  }

  if (needDollarSign.includes(key)) {
    return moneyFormatter(value);
  }

  if (key === 'TaskOrderNumber' && value === i18n.t('common:Not Specified')) {
    return '';
  }

  if (key === 'POAFENumber') {
    const POAFENumber = value.split(',').includes(i18n.t('common:Not Specified')) ? value.split(',').filter(item => item !== i18n.t('common:Not Specified')).join(',') : value;

    return (<TruncateToolTip text={POAFENumber} delimiter="," />);
  }

  return value;
};

export default SplitReportTableTemplate


// WEBPACK FOOTER //
// ./src/containers/Jobs/SplitReportTab/SplitReportTableTemplate.jsx